import {
  Outlet,
  useNavigate,
  useLoaderData,
  useLocation,
} from "react-router-dom";
import {
  ToggleButton,
  ToggleButtonGroup,
  Box,
  Typography,
  Stack,
} from "@mui/material";
import { enqueueSnackbar, SnackbarProvider } from "notistack";
import { useEffect, useState } from "react";
import {
  CustomTitle,
  DateFormater,
  formatAmount,
  handleSessionOut,
  Loader,
} from "../HelperFunctions/HelperFunctions";
import Alert from "@mui/material/Alert";
import { getToken } from "../API/tokenStore";
import CryptoJS from "crypto-js";

const ReconciliationLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { headerCorporation, corporations, userId, clientId, Previlage, clientName, authId, menuId, corpId ,from_todate} =
    useLoaderData();
  const selectedTab = location.pathname.includes("chargebacks")
    ? "Chargebacks"
    : "DS_Cards";
  const [tabValues, setTabValues] = useState([
    { tabName: "DS_Cards", count: 0, amount: 0 },
    { tabName: "Chargebacks", count: 0, amount: 0 },
  ]);
  const tabRoutes = {
    "DS Cards": "ds-cards",
    "Chargebacks": "chargebacks"
  };
  const [merchantProvider, setMerchantProvider] = useState(null);

  const parts = from_todate?.split("&")?.[1]?.split("-");
  const dateFromUrl = parts
    ? new Date(parts[2], parts[0] - 1, parts[1])
    : null;
  const [date, setDate] = useState(dateFromUrl ?? new Date());
  // const [date, setDate] = useState(new Date());
  const [restartSSE, setRestartSSE] = useState(false);

  const [selectedCorp, setSelectedCorp] = useState(() => {
    if (headerCorporation) {
      return (
        corporations.find((corp) => corp.ID === headerCorporation) ||
        corporations[0]
      );
    }
    return corporations[0];
  });
  const token = getToken();
  const SECRET = "12345678901234567890123456789012";
  const encrypted = CryptoJS.AES.encrypt(token, SECRET).toString();

  useEffect(() => {
    setLoading(true);

    const corp_id = selectedCorp?.ID === "select" ? "" : selectedCorp?.ID;

    const formattedDate = date ? DateFormater(date) : "";

    const dateRegex = /^(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])-\d{4}$/;

    if (!dateRegex.test(formattedDate)) {
      setLoading(false);
      return
    };
    // const url = `${
    //   process.env.REACT_APP_BACKEND_API_URL
    // }/dscards_tabs?client_id=${clientId}&corp_id=${corp_id}&token=${encodeURIComponent(
    //     encrypted
    //   )}`;

    const url = `${process.env.REACT_APP_BACKEND_API_URL
      }/API/dscards_tabs?client_id=${clientId}&corp_id=${corp_id}&as_of_date=${formattedDate}&token=${encodeURIComponent(
        encrypted
      )}`;

    const eventSource = new EventSource(url);

    eventSource.onmessage = (event) => {
      try {
        const rawData = JSON.parse(event.data);
        if (rawData?.status === 401) {
          handleSessionOut();
          // eventSource.close();
          return;
        }


        const normalizedTabs = [
          { tabName: "DS_Cards", count: 0, amount: 0 },
          { tabName: "Chargebacks", count: 0, amount: 0 },
        ];

        rawData.forEach((item) => {
          const index = normalizedTabs.findIndex(
            (tab) => tab.tabName === item.tabName
          );

          if (index !== -1) {
            normalizedTabs[index] = {
              ...normalizedTabs[index],
              count: item.count,
              amount: item.amount,
            };
          }
        });




        setTabValues(normalizedTabs);
        setLoading(false);
      } catch (err) {
        console.error("Invalid SSE data:", err);
        setLoading(false);
      }
    };

    eventSource.onerror = (error) => {
      enqueueSnackbar("Error while getting DS Card Tabs", {
        variant: "error",
      });
      setLoading(false);
      eventSource.close();
    };

    return () => {
      setLoading(false);
      eventSource.close();
    };
  }, [selectedCorp, date, restartSSE]);



  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedTab !== "Chargebacks") {
      // setSelectedCorporation(null);
      setMerchantProvider(null);
    }
    const tabPath = tabRoutes[selectedTab];

    if (tabPath) {
      navigate(
        `/reconciliation/${clientName}/${authId}/${menuId}/${corpId}/${tabPath}`,
        { replace: true }
      );
    }
  }, [selectedTab]);


  const TabHeading = ({ tab }) => (
    <Stack>
      <Typography noWrap sx={{ fontSize: 14, fontWeight: 500, px: 8 }}>
        {CustomTitle(tab.tabName)}{" "}
        <span style={{ fontSize: 12 }}>({tab.count})</span>
      </Typography>
      <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
        {`$ ${formatAmount(tab.amount)}`}
      </Typography>
    </Stack>
  );


  // if (!Previlage?.[0]?.View) {
  //   return (
  //     <Stack alignItems="center" justifyContent="center" height="100%">
  //       <Alert severity="warning">
  //         You do not have permission to view this screen.
  //       </Alert>
  //     </Stack>
  //   );
  // }

  return (
    <SnackbarProvider
      maxSnack={1}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={2000}
    >
      <Stack height={"100%"} gap={3} p={0.5}>
        {/* Tab Switcher */}
        <Box alignSelf={"center"}>
          <ToggleButtonGroup
            value={selectedTab}
            exclusive
            onChange={(e, newTab) => {
              if (!newTab) return;
              if (newTab === "DS_Cards") navigate("ds-cards");
              if (newTab === "Chargebacks") navigate("chargebacks");
            }}
            sx={{ borderRadius: 20 }}
          >
            {tabValues.map((tab) => (
              <ToggleButton
                key={tab.tabName}
                value={tab.tabName}
                sx={{
                  p: 1,
                  color: "black",
                  borderRadius: 2,
                  textTransform: "none",
                  "&.Mui-selected": { backgroundColor: "#bee9e9" },
                  "&.Mui-selected:hover": {
                    backgroundColor: "#bee9e9",
                  },
                }}
              >
                <TabHeading tab={tab} />
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>

        <Box sx={{ flex: 1, overflow: "auto" }}>
          <Outlet
            context={{
              selectedCorp,
              setSelectedCorp,
              // fetchTabValues,
              merchantProvider,
              setMerchantProvider,
              date,
              setDate,

              restartSSE,
              setRestartSSE
            }}
          />
        </Box>
      </Stack>
      {loading && <Loader loading={loading} />}
    </SnackbarProvider>
  );
};
export default ReconciliationLayout;
